// Module
var code = "<style>:host{display:block}img{height:100%;width:100%}</style> <img id=\"image\">";
// Exports
export default code;